module.exports = __webpack_public_path__ + "img/selected-ballad-in-goblets-3.367b6ad8.webp";